const normalizeDiacritics = /[\u0300-\u036f]/g;

export function normalize(input: string): string {
  return input.normalize('NFD').replace(normalizeDiacritics, '').toLowerCase();
}

export function asciiContains(value: string, query: string): boolean {
  return !!value && normalize(value).indexOf(query) >= 0;
}
